import React, { useEffect, useState } from 'react';
import { FiChevronRight } from "react-icons/fi";
import { Link } from 'react-router-dom';
import axios from 'axios';

const NewsletterArchives = () => {
  const [newsletters, setNewsletters] = useState([]);

  useEffect(() => {
    axios.get('/api/news?post=all').then(response => {
      setNewsletters(response.data);
      console.log(response.data);
    })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const formatPostDate = (postDate) => {
    // don't do this kids, I just don't want to fix the timezone shit
    const date = new Date((parseInt(postDate, 10) + 29000) * 1000);
    const options = { month: 'long' };
    const monthName = date.toLocaleDateString(undefined, options);
    return monthName + ' ' + date.getDate() + ", " + date.getFullYear();
  };

  return (
    <section className="section-padding all-blog2 bg-one header-padding">
      <div className="container">
        <div className="row">
          <div
            id="right"
            className="col-md-5 col-lg-4 col-xl-3"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="all-blog2__sidebar">
              <div className="all-blog2__sidebar__archive item-border">
                <h2 className="fs-4 mb-3"><Link to='/newsletter-archive'>Archives</Link></h2>
                <ul>
                  {newsletters.map((newsletter) => (
                    <li key={newsletter.date}>
                      <Link to={'/newsletter-post?post=' + newsletter.id}>{formatPostDate(newsletter.date)}</Link>&nbsp;
                    </li>
                  ))}
                </ul>
              </div>
              <div className="all-blog2__sidebar__social item-border">
                <h2 className="fs-4 mb-3">Social</h2>
                <ul className="social-icon my-4">
                  <li key='social_insta'>
                    <a href="https://instagram.com/jutefoster" target="_blank" rel="noopener noreferrer" >
                      <img
                        className="img-fluid"
                        src="assets/icons/Instagram_Glyph_White.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                  <li key='social_discord'>
                    <a href="https://discord.gg/JUcBUxuYUd" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/Discord-Symbol-White.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                  <li key='social_facebook'>
                    <a href="https://facebook.com/jutefoster" target="_blank" rel="noopener noreferrer">
                      <img
                        className="img-fluid"
                        src="assets/icons/facebook.svg"
                        alt="icon"
                        width="25"
                        height="25"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className="col-md-7 col-lg-8 col-xl-9 mb-4 mb-md-0"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            {newsletters.map((newsletter) => (
              <div key={newsletter.id} className="all-blog2__area">
                <div className="all-blog2__area__image">
                  <img
                    className="img-fluid"
                    src={'api/' + newsletter.postImage}
                    alt="blog_04"
                  />
                </div>
                <div className="all-blog2__area__menu">
                  <ul>
                    <li key={newsletter.date}>{formatPostDate(newsletter.date)}</li>
                  </ul>
                  <h2 className="fs-2">
                    <Link to={'/newsletter-post?post=' + newsletter.id}>{newsletter.title}</Link>
                  </h2>
                  <p>
                    <div dangerouslySetInnerHTML={{ __html: newsletter.blurb}} />
                  </p>
                  <Link to={'/newsletter-post?post=' + newsletter.id} className="link">
                    Read more<i className="icofont-rounded-right"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsletterArchives;